module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES89UC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + " - " + _vm._s(_vm.detail.tab1.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.codcomp1) + "-" + _vm._s(_vm.detail.tab1.codcomp2) + "-" + _vm._s(_vm.detail.tab1.codcomp3) + "-" + _vm._s(_vm.detail.tab1.codcomp4) + "-" + _vm._s(_vm.detail.tab1.codcomp5) + "-" + _vm._s(_vm.detail.tab1.codcomp6) + "-" + _vm._s(_vm.detail.tab1.codcomp7) + " - " + _vm._s(_vm.detail.tab1.desc_codcomp) + "\n        \n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codpos",
      "name": "coddesc_codpos"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codpos) + " - " + _vm._s(_vm.detail.tab1.desc_codpos))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "numreqst",
      "name": "numreqst"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.numreqst))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codjob",
      "name": "coddesc_codjob"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codjob) + " - " + _vm._s(_vm.detail.tab1.desc_codjob))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codempmt",
      "name": "coddesc_codempmt"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempmt) + " - " + _vm._s(_vm.detail.tab1.desc_codempmt))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.qtydatrqyr),
      expression: "detail.tab1.qtydatrqyr"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "qtydatrqyr",
      "name": "qtydatrqyr"
    },
    domProps: {
      "value": (_vm.detail.tab1.qtydatrqyr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "qtydatrqyr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['120']))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.qtydatrqmth),
      expression: "detail.tab1.qtydatrqmth"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "qtydatrqmth",
      "name": "qtydatrqmth"
    },
    domProps: {
      "value": (_vm.detail.tab1.qtydatrqmth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "qtydatrqmth", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['130']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.amtincom),
      expression: "detail.tab1.amtincom"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "amtincom",
      "name": "amtincom"
    },
    domProps: {
      "value": (_vm.detail.tab1.amtincom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "amtincom", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['150']))])]), _vm._v(" "), _c('div', {
    staticClass: "text-error",
    attrs: {
      "id": "form-errors-p_amtwidrw"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "desc_codrearq",
      "name": "desc_codrearq"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codrearq))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.flgrecut),
      expression: "detail.tab1.flgrecut"
    }],
    attrs: {
      "type": "radio",
      "value": "I",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.flgrecut, "I")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "flgrecut", "I")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['180']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.flgrecut),
      expression: "detail.tab1.flgrecut"
    }],
    attrs: {
      "type": "radio",
      "value": "E",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.flgrecut, "E")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "flgrecut", "E")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['190']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70 txtarea-width response-full-width",
    attrs: {
      "id": "desnote",
      "name": "desnote"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desnote))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flgjob),
      expression: "flgjob"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": "disabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.flgjob) ? _vm._i(_vm.flgjob, null) > -1 : (_vm.flgjob)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flgjob,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flgjob = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flgjob = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flgjob = $$c
        }
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES89UC3']['220']) + "\n                    "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "detail-text width-70 txtarea-width response-full-width",
    attrs: {
      "id": "syncond1",
      "name": "syncond1"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.syncond1))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flgcond),
      expression: "flgcond"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": "disabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.flgcond) ? _vm._i(_vm.flgcond, null) > -1 : (_vm.flgcond)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flgcond,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flgcond = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flgcond = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flgcond = $$c
        }
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES89UC3']['230']) + "\n                    "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "detail-text width-70 txtarea-width response-full-width",
    attrs: {
      "id": "syncond2",
      "name": "syncond2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.syncond2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "qtyreq",
      "name": "qtyreq"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.qtyreq))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES89UC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtereqm",
      "name": "dtereqm"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereqm)))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-080dfd4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres89u/detail.vue
// module id = 3520
// module chunks = 1